module.exports = __webpack_public_path__ + "img/1.b08cbf46.png";